import styled from '@emotion/styled'

import { palette, typography } from '../constants'

interface IProps {
  muted?: boolean
  strong?: boolean
}

export default styled.span<IProps>`
  color: ${({ muted }) => (muted ? palette.slate : palette.almostBlack)};
  font-family: ${typography.fontFamily.ui};
  font-size: ${typography.fontSize.small};
  font-weight: ${({ strong }) =>
    strong ? typography.fontWeight.bold : typography.fontWeight.regular};
  line-height: 20px;
`
